import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import useDidUpdateEffect from '../hooks/useDidUpdateEffect';
import {applyCreditAndGetOrderSummary} from '../v2/actions/paymentActions/accountCredit/accountCreditActions';
import {isCreditUsed} from '../v2/selectors/selectors';

// To allow for conditional rendering of components, anywhere they're listening for changes we're going to
// shove them in here as a quick fix. If this gets big we'll put them in separate ones like PaymentListener, etc

export function CreditListener(props) {
  useDidUpdateEffect(() => {
    if (!props.isVariableCreditEnabled && props.isCreditApplied) {
      props.applyCreditAndGetOrderSummary(props.applicableCreditNumeric);
    }
  }, [props.applicableCreditNumeric, props.isVariableCreditEnabled, props.isCreditApplied]);
  
  return null;
}

CreditListener.propTypes = {
  isVariableCreditEnabled: PropTypes.number.isRequired,
  isCreditApplied: PropTypes.number.isRequired,
  applicableCreditNumeric: PropTypes.number.isRequired,
  applyCreditAndGetOrderSummary: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isVariableCreditEnabled: !!state.start.settings.variable_credit_enabled,
  isCreditApplied: isCreditUsed(state),
  applicableCreditNumeric: state.orderSummary.credit.applicable.value,
});

const mapDispatchToProps = {applyCreditAndGetOrderSummary};

export default connect(mapStateToProps, mapDispatchToProps)(CreditListener);
